export default __webpack_public_path__ + "static/2-7dfb2eee8ec446db60a2bde2771833cd.jpg";